import { render, staticRenderFns } from "./promotion-rag-colour-icon-wrapper.vue?vue&type=template&id=69b26982&scoped=true"
import script from "./promotion-rag-colour-icon-wrapper.vue?vue&type=script&lang=js"
export * from "./promotion-rag-colour-icon-wrapper.vue?vue&type=script&lang=js"
import style0 from "./promotion-rag-colour-icon-wrapper.vue?vue&type=style&index=0&id=69b26982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b26982",
  null
  
)

export default component.exports